export default __webpack_public_path__ + "static/media/coinmarket-logo.d126cd96.svg";